import React, { useEffect, useState } from "react";
import logo from '../../assets/img/logo.png';
import './Login.styles.scss'
import Button from '../../components/atoms/Boton/Button';
import { ColorValidation, SubmitValidation, UpdateValue } from "../../utilities/Validaciones";
import { login } from "./Login.service";
import { useNavigate, useParams } from "react-router-dom";
import err from "../../assets/img/error.svg";

const Login = () => {
    const { company } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [inputList,setInputList] = useState({
        nip: { value: null, validationType: 'empty' },
    })
    useEffect(()=> {
        for (const inputListKey in inputList) {
            if (document.getElementById(inputListKey)) {
                // @ts-ignore
                ColorValidation(inputListKey, inputList)
            }

        }
    }, [inputList])

    const submit = async ()=>
    {
        if(SubmitValidation(inputList,setInputList) && inputList.nip.value)
        {
            await login(inputList.nip.value, company?.toLowerCase(), navigate, setError);
        }
    }

    return (
        <div className="background">
            <div className="container">
                <div className="logo">
                    <img src={logo} alt="Logo"/>
                </div>
                <span className="span">Por favor introduce el NIP para ingresar </span>
                <div className="input-container">
                    <input type="number" id="nip" placeholder="Ingrese el NIP" onChange={(e) => {
                        UpdateValue(e, "nip", inputList, setInputList)
                    }}/>
                </div>
                {
                    error ? <div className={'error'}>
                        <img src={err} alt={'error'}/><span>NIP incorrecto inténtelo de nuevo</span>
                    </div> : ''
                }

                <div className="login-button">
                    <Button className="button-login" onClick={submit}>Ingresar</Button>
                </div>
            </div>
        </div>

    )
}

export default Login
